module.exports = "/_next/static/images/0817cf38223a38f0b0b2297e2952362f-purple-phone-icon.svg.webp";